/**
 * Primitives every module's schemas build on — DESIGN.md §12.1, §12.3.
 */
import { z } from 'zod';
import { DEFAULT_PAGE_SIZE, MAX_PAGE_SIZE } from '../constants.js';
export const uuidSchema = z.string().uuid();
export const emailSchema = z.string().email().max(320).trim().toLowerCase();
/** Plain calendar date, `YYYY-MM-DD` — due dates are dates, not datetimes (D10). */
export const dateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD')
    .refine((value) => !Number.isNaN(Date.parse(`${value}T00:00:00Z`)), 'Not a real date');
/** ISO-8601 UTC instant. */
export const instantSchema = z.string().datetime({ offset: true });
/** A hex colour for statuses, tags, projects, and field options. */
export const colorSchema = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'Expected #rrggbb');
/** Fractional index position (§6.3.1). */
export const positionSchema = z.string().min(1).max(400);
/** Cursor pagination request fragment — mixed into list query schemas. */
export const paginationSchema = z.object({
    cursor: z.string().max(2048).nullish(),
    limit: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
});
export function pageSchema(item) {
    return z.object({
        items: z.array(item),
        cursor: z.object({ next: z.string().nullable() }),
        totalCount: z.number().int().nonnegative(),
    });
}
/**
 * The bound on a card title. Named because two things have to agree on it: the
 * create/update schemas below, and #59's mark, which is appended to a title at
 * creation and must land inside the same bound.
 */
export const TITLE_MAX_LENGTH = 500;
/** Trimmed, non-empty display string with an upper bound. */
export function name(max) {
    return z.string().trim().min(1).max(max);
}
/** Optional trimmed string that normalises `''` to `null`. */
export function optionalText(max) {
    return z
        .string()
        .trim()
        .max(max)
        .transform((v) => (v === '' ? null : v))
        .nullish();
}
//# sourceMappingURL=common.js.map